// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-toast-message {
  background-color: #222222;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
}

.p-toast-message-content {
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: center;
  gap: 12px;
}

.p-toast-message-text {
  font-size: 14px;
  color: var(--white-text-color);
  font-weight: 600;
}

.p-toast-icon-close {
  color: var(--secondary-accent-text-color);
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

@media (max-width: 768px) {
  .p-toast {
    max-width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/toast.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".p-toast-message {\n  background-color: #222222;\n  border-radius: 4px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.p-toast-message-content {\n  display: grid;\n  grid-template-columns: 1fr min-content;\n  align-items: center;\n  gap: 12px;\n}\n\n.p-toast-message-text {\n  font-size: 14px;\n  color: var(--white-text-color);\n  font-weight: 600;\n}\n\n.p-toast-icon-close {\n  color: var(--secondary-accent-text-color);\n}\n\n.toast-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .p-toast {\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
